import { Iterable } from 'immutable';

const resolve = (path, actobj, separator='.') => {
  const obj = Iterable.isIterable(actobj) ? actobj.toJS() : actobj;
  const properties = Array.isArray(path) ? path : path.split(separator)
  return properties.reduce((prev, curr) => prev && prev[curr], obj)
}

export default resolve;